import { MenuItem, withStyles } from '@material-ui/core';

export const StyledMenuItem = withStyles(() => ({
    root: {
        padding: '6px 18px',
    },
}))(MenuItem);
